import React from 'react';

const STATUS_STYLES = {
  Healthy: {
    bg: '#dcfce7',
    color: '#16a34a',
    dot: '#16a34a',
    label: 'Healthy',
  },
  'Low Stock': {
    bg: '#fef3c7',
    color: '#92400e',
    dot: '#f59e0b',
    label: 'Low Stock',
  },
  Critical: {
    bg: '#fee2e2',
    color: '#dc2626',
    dot: '#dc2226',
    label: 'Critical',
  },
  Exhausted: {
    bg: '#f3f4f6',
    color: '#374151',
    dot: '#374151',
    label: 'Exhausted',
  },
};

const deriveBatchStatus = (batch) => {
  if (batch.is_exhausted || Number(batch.quantity_remaining) <= 0) return 'Exhausted';
  const purchased = Number(batch.purchase_quantity);
  const remaining = Number(batch.quantity_remaining);
  if (purchased <= 0) return 'Exhausted';
  const remainingPct = (remaining / purchased) * 100;
  if (remainingPct > 50) return 'Healthy';
  if (remainingPct > 20) return 'Low Stock';
  return 'Critical';
};

const PurchaseStatusBadge = ({ batch }) => {
  const status = deriveBatchStatus(batch);
  const s = STATUS_STYLES[status];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        backgroundColor: s.bg,
        color: s.color,
        padding: '3px 10px',
        borderRadius: '12px',
        fontSize: '11px',
        fontWeight: '600',
        whiteSpace: 'nowrap',
        lineHeight: '18px',
      }}
    >
      <span
        style={{
          width: '7px',
          height: '7px',
          borderRadius: '50%',
          backgroundColor: s.dot,
          flexShrink: 0,
        }}
      />
      {s.label}
    </span>
  );
};

export default React.memo(PurchaseStatusBadge);
